import Vue from 'vue';
import Hammer from 'hammerjs';
Vue.directive('gesture', {
    bind: function (el, binding) {
        if (typeof binding.value === 'function') {
            var h = new Hammer(el);
            h.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
            h.get('pan').set({ direction: Hammer.DIRECTION_ALL });
            h.on(binding.arg, binding.value);
        }
    }
});
